import { MID_PAGE_CTA_EXPERIMENT_NAME, midPageCtaExperimentPageList } from 'lib/experiments';
import { useEffect, useState } from 'react';
import { retrieval } from 'utilities/src/experiments/utils/client-utils';

interface Args {
  slug: string;
}

export default function useBannerCtaExperiment({ slug }: Args) {
  const [experimentEnabled, setExperimentEnabled] = useState(false);

  useEffect(() => {
    if (!midPageCtaExperimentPageList.has(`/${slug}/`)) return;
    const retrivalInstance = retrieval();
    const experiment = retrivalInstance.byExperiment(
      retrivalInstance.fromCookie(slug),
      MID_PAGE_CTA_EXPERIMENT_NAME,
    );
    setExperimentEnabled(experiment?.variation === 'Treatment');
  }, [slug]);

  return { experimentEnabled };
}
